import { Navigate, Route, Routes } from 'react-router'
import { NewInboxRoutes } from 'pages/settings/pages/inboxes/route/type'
import { TextEnableLandlineAccessLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/layout/TextEnableLandlineAccessLayout'
import { TextEnableLandlineLayout } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/layout/TextEnableLandlineLayout'
import { EnterNumber } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/ui/EnterNumber/EnterNumber'
import { EnterAddress } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/ui/EnterAddress/EnterAddress'
import { VerifyNumber } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/ui/VerifyNumber/VerifyNumber'
import { AuthorizationDocument } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/ui/AuthorizationDocument/AuthorizationDocument'
import { Payment } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/ui/Payment/Payment'

export const TextEnableLandlineRouter = () => {
  return (
    <Routes>
      <Route element={<TextEnableLandlineAccessLayout />}>
        <Route element={<TextEnableLandlineLayout />}>
          <Route index element={<Navigate to={NewInboxRoutes.enterNumber} replace />} />
          <Route path={NewInboxRoutes.enterNumber} element={<EnterNumber />} />
          <Route path={NewInboxRoutes.enterAddress} element={<EnterAddress />} />
          <Route path={NewInboxRoutes.verifyNumber} element={<VerifyNumber />} />
          <Route path={NewInboxRoutes.authorizationDocument} element={<AuthorizationDocument />} />
          <Route path={NewInboxRoutes.payment} element={<Payment />} />
        </Route>
      </Route>
    </Routes>
  )
}
